<template>
  <div class="brand-info">
    <div class="wrapper">
        <h1 id="brand-name">{{ searchResult.name }}</h1>
        <div id="brand-label">{{ $t("brand") }}</div>
    </div>
    <div class="heading">{{ $t("producersLabel") }}</div>
    <div v-for="producer in correspondingNames" v-bind:key="producer.id" class="producer">
      <div class="producer-heading">
        <h2 class="producer-name" @click="navigateToProducer(producer)">{{ producer.name }}</h2>
        <img class="link-arrow" src="@/assets/images/arrow-right.svg" />
      </div>

      <div class="town-name" @click="navigateToMap(producer)">{{ producer.town.name }}</div>
      <img class="map-marker" src="@/assets/images/map-marker.svg" />
      <div class="municipality-state">
      <span class="municipality">{{ producer.municipality.name }}, </span>
      <span class="state">{{ producer.state.name }}</span>
    </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'BrandInfo',
  components: {
  },
  computed: {
    
  },
  mounted(){

  },
  props: {
    searchResult: Object,
    correspondingNames: Array,
  },
  data () {
    return {
    }
  },
  methods: {
    navigateToProducer(clickedLink){
      this.$emit("searchSelected", clickedLink);
    },
    navigateToMap(producer){
      this.$router.push('Maps');
      this.$store.commit("changeCurrentTown", producer.town)
    }
  }
}
</script>

<style lang="scss" scoped>

h1 {
  font-family: 'futura';
  margin-top: 20px;
  margin-bottom: 0;
}

.producer {
  padding-right: 20px;
  margin-bottom: 11px;
  padding-bottom: 11px;
  border-bottom: 1px solid #ccc;
}


.heading {
  margin-bottom: 10px;
  font-family: 'optima';
  font-size: 18px;
  font-weight: 100;
  color: grey;
  border-bottom: 1px solid #ccc;
}

.producer-name {
  font-size: 28px;
  font-weight: 400;
  max-width: 280px;
  display: inline;
}

.producer-name:hover, .producer-name:active, .town-name:hover, .town-name:active {
  color: grey;
}

.brands-list {
  font-size: 24px;
  font-weight: 400;
  margin-left: 30px;
}

.town-name {
    font-size: 20px;
    margin-top: 3px;
    display: inline-block;
}

.municipality-state {
  margin-top: 2px;
  font-size: 14px;
  font-weight: lighter;
  color: grey;
}

.wrapper {
  display: inline-block;
}

.link-arrow {
  height: 12px;
  margin-left: 5px;
  margin-bottom: 10px
}

.map-marker {
  height: 12px;
  width: 12px;
  margin-left: 3px;
  margin-bottom: 8px
}

#brand-label {
  margin-top: -2px;
  float: right;
  font-size: 14px;
  color: grey;
}


</style>
